import { ERROR_CODE as n } from "../../constants/error.js";
import { CustomError as s } from "../../errors/customError.js";
import a from "query-string";
const i = async (e, r, t) => {
  const c = await (await fetch(
    a.stringifyUrl({ url: r, query: { buildId: e } }),
    {
      method: "GET",
      headers: {
        "cache-control": "no-cache",
        "content-type": "application/xml"
      }
    }
  )).text();
  return t(c);
}, f = async (e, r, t, o) => {
  try {
    await e.prefetchQuery({
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: [t],
      queryFn: () => i(r, t, o)
    });
  } catch {
    throw new s(
      `Cannot fetch static rss data from: ${t}`,
      n.FETCH.CANNOT_FETCH_RSS
    );
  }
};
export {
  i as fetchRss,
  f as prefetchRss
};
//# sourceMappingURL=fetchRss.js.map
